module.exports = __webpack_public_path__ + "img/187w.81934f4.jpg";